import { Button, cn, Icon, Input, Typography } from "@kyan/ui";

import { match } from "#/utils/match";

import { useRefCodeInputController } from "./RefCodeInput.controller";

interface RefCodeInputProps {
  variant?: "inline" | "standalone";
  className?: string;
  onSuccess?: () => void;
}

export const RefCodeInput: React.FC<RefCodeInputProps> = ({
  variant = "inline",
  className,
  onSuccess,
}) => {
  const {
    error,
    isPending,
    isSuccess,
    refCode,
    handleApply,
    handleInputChange,
  } = useRefCodeInputController({ onSuccess });

  if (variant === "standalone") {
    return (
      <div className={cn("flex flex-col gap-4", className)}>
        <Input
          label="Code"
          value={refCode}
          error={Boolean(error)}
          placeholder="Referral code"
          inputWrapperClassName="dark:bg-buttonFill"
          onChange={handleInputChange}
        />
        <Button
          size="xl"
          className="w-full"
          isLoading={isPending}
          disabled={!refCode || isPending}
          onClick={handleApply}
        >
          Apply
        </Button>
      </div>
    );
  }

  const rightSlot = match([
    [
      <Button
        key="apply"
        variant="link"
        isLoading={isPending}
        disabled={!refCode || isPending}
        onClick={handleApply}
      >
        Apply
      </Button>,
      !isSuccess && !error,
    ],
    [
      <Typography key="error" className="text-error">
        {error}
      </Typography>,
      Boolean(error),
    ],
    [
      <Icon size="sm" key="close" name="checkmark" className="text-success" />,
      isSuccess,
    ],
  ]);

  return (
    <Input
      value={refCode}
      rightSlot={rightSlot}
      error={Boolean(error)}
      placeholder="Referral code (optional)"
      inputWrapperClassName="dark:bg-buttonFill h-13.5 pr-4"
      onChange={handleInputChange}
    />
  );
};
